<template>
    <div :id="id" class="transition-group-form">
        <slot 
            :formData="formData" 
            :loading="loading" 
            :activeStep="activeStep"
            :response="response"
            :submitForm="submitForm"
            :quizSubmitForm="quizSubmitForm" 
            :resetForm="resetForm" 
            :sendEmail="sendEmail"
            :categoryList="categoryList"
        />
    </div>
</template>

<script>
    import axios from 'axios';
    import inputEventBus from '@/mixins/input-eventbus';
    import closest from '@/mixins/closest';
    import pageGoalsMixin from '@/mixins/page-goals';
    import ahaLoadingSpinner from "./aha-loading-spinner.vue";


    export default {
        mixins: [pageGoalsMixin],
        inject: ['EventBus'],
        components: {
            "aha-loading-spinner": ahaLoadingSpinner,
        },
        props: {
            errorStepKey: {
                type: Number,
                required: true
            },
            url: {
                type: String,
                required: true
            },
            emailUrl: {
                type: String,
                required: false
            },
            quizId: {
                type: String,
                required: false
            },
            quizName: {
                type: String,
                required: false
            }
        },
        data() {
            return {
                loading: false,
                formData: {
                    symptoms: []
                },
                response: {},
                activeStep: 1,
                id: 'component_uid_' + this._uid,
                checkedItems: [],
                categoryType: [],
            }
        },
        computed: {
            categoryList: function() {
                if(this.formData.symptoms) {
                    let finalCategoryList = {};
                    if (this.categoryType.length) {
                        this.categoryType.filter(categorytype => {
                            const category = [];
                            this.formData.symptoms.filter(element => {
                                if (element.category === categorytype.category) {
                                    category.push(element);
                                } else if (categorytype.remainingCategory.includes(element.category)) {
                                    category.push(element);
                                }
                            })
                            if (category.length) {
                                finalCategoryList = { ...finalCategoryList, [`${categorytype.category}`]: category};
                            }
                        });
                    }
                    return finalCategoryList;
                }
            },
        },
       
        methods: {
            submitForm(evt) {
                evt.preventDefault();
                this.loading = true;
                const showNumberOfResultCards = +(evt.target.getAttribute('data-displaycategorycount'));
                const eventName = evt.target.getAttribute('data-eventname');
                const eventparameters = evt.target.getAttribute('data-eventparameters');
                const eventSendTo = evt.target.getAttribute('data-send-to');
                if(eventName && eventparameters) {
                    const rawObject = eventparameters.split(',').map(i => (i.split(':')).map(j => j.trim()));
                    const eventObject = Object.fromEntries(rawObject);
                    const eventNewObj = {};
                    for (const key in eventObject) {
                        const newKey = (key.replace(/\s/g, '_')).toLowerCase();
                        eventNewObj[newKey] = eventObject[key];
                    }
                    eventNewObj.send_to = eventSendTo;
                    window.gtag('event', eventName, eventNewObj);
                }
                axios({
                    method: 'POST',
                    url: this.url,
                    responseType: 'json',
                    data: this.formData
                }).then(response => {
                    console.log('response: ', response);
                    this.categoryType.sort((a, b) => b.priority - a.priority);
                    if (showNumberOfResultCards && this.categoryType.length >= showNumberOfResultCards) {
                        this.categoryType.map((item, index) => {
                            const temp = item;
                            if (!(showNumberOfResultCards >= (+index + 1))) {
                                this.categoryType[0].remainingCategory.push(item.category);
                            }
                            return temp;
                        });
                        this.categoryType.length = showNumberOfResultCards;
                    }
                    setTimeout(() => { this.AddedFullWidthClassSingleResultCard(showNumberOfResultCards); }, 100);
                    if(this.$attrs && this.$attrs['data-quiz-type'] && this.$attrs['data-quiz-type'] === 'symptom-checker' && response.status == 200) {
                        // bypass and go directly to last slide
                        this.EventBus.$emit('stepTrigger');
                    } else {
                         if(response.data === null) {
                            this.EventBus.$emit('stepTrigger', this.errorStepKey);
                        } else {
                            this.response = response.data;
                            this.EventBus.$emit('stepTrigger');
                        }
                    }
                   
                    this.loading = false;
                }).catch(error => {
                    console.log('Error: ', error)
                    const step = this.activeStep;
                    this.EventBus.$emit('stepTrigger', this.errorStepKey);  
                    this.activeStep = step;
                    
                    
                    this.loading = false;
                })
            },
            AddedFullWidthClassSingleResultCard(showNumberOfResultCards) {
                const summaryCard = document.querySelectorAll('.summary-card');
                const categoryObjectLenght = Object.keys(this.categoryList).length;
                summaryCard.forEach((element) => {
                    if (element.style.display === '' && (showNumberOfResultCards === 1 || categoryObjectLenght === 1)) {
                        element.classList.add("single-card-full-width");
                    } else {
                        element.classList.remove("single-card-full-width");
                    }
                });
            },
            quizSubmitForm(evt) {
                evt.preventDefault();
                this.loading = true;
                axios({
                    method: 'POST',
                    url: this.url,
                    responseType: 'json',
                    data: this.formData
                }).then(response => {
                    if(response.data === null) {
                        this.EventBus.$emit('stepTrigger', this.errorStepKey);
                        // this.EventBus.$emit('stepTrigger');
                    } else {
                        this.response = response.data;
                        this.formData = {};
                        this.formData.QuizData = this.response.QuizData;
                        this.response.QuizData = JSON.parse(response.data.QuizData);
                        this.formData.TotalScore = this.response.Summary.TotalScore;
                        this.formData.TotalScoreHash = this.response.Summary.TotalScoreHash;
                        if(this.response.ResponseTitle === null && this.response.ResponseText === null) {
                            this.EventBus.$emit('stepTrigger', this.activeStep + 2);
                        } else {
                            this.EventBus.$emit('stepTrigger');
                        }
                    }
                    this.loading = false;
                }).catch(error => {
                    console.log(error);
                    const step = this.activeStep;
                    this.EventBus.$emit('stepTrigger', this.errorStepKey);
                    // this.EventBus.$emit('stepTrigger');
                    this.activeStep = step;
                    this.loading = false;
                })
            },
            resetForm(evt) {
                // this.formData = {};
                this.categoryType = [];
                for (let k of Object.keys(this.formData)) {
                    if(Array.isArray(this.formData[k])) {
                        this.formData[k] = []
                    } else {
                        this.formData[k] = ''
                    }
                }

                this.EventBus.$emit('stepTrigger', 1);
                inputEventBus.$emit('inputCleared');
            },
            checkParent(el) {
                const root = '#' + this.id;
                const parent = closest(el, root);
                if(this.$el === parent) {
                    return true;
                } else {
                    return false;
                }
            },
            clearCheckboxes() {
                const checkboxes = document.querySelectorAll('input[type=checkbox]:checked')
                for (var i = 0; i < checkboxes.length; i++) {
                    checkboxes[i].checked = false;
                }
            },
            clearAnswers() {
                this.clearCheckboxes();
                this.formData.AnswerId = null;
            },
            getCheckedItems(id) {
                let checked = []
                const checkboxes = document.querySelectorAll('input[type=checkbox]:checked')

                for (var i = 0; i < checkboxes.length; i++) {
                    checked.push(checkboxes[i].value)
                }

                if(checked.length > 0) {
                    this.formData[id] = checked;
                } else {
                    this.formData[id] = false;
                }

            },
            sendEmail(evt) {
                // prevent the form submission
                // don't need to submit the form
                // need to keep this modal open for the screen reader and not close with a timer
                evt.target.onsubmit = (evt) => {
                    evt.preventDefault();
                    // console.log('onsubmit from email modal');
                }

                // Goal Triggering
                const submitBtn = evt.target.querySelector('[type="submit"]');
                if(submitBtn && submitBtn.dataset.tracking){
                    const goalData = submitBtn.dataset.tracking;
                    this.triggerPageGoals(goalData);
                }
                // End Goal Triggering

                let emailData = {};

                emailData['QuizId'] = this.response.QuizId;
                emailData['EmailTo'] = this.$el.querySelector('#email').value;
                emailData['EmailBody'] = this.$el.querySelector('#print-section').innerHTML;
                axios({
                    method: 'POST',
                    url: this.emailUrl,
                    data: emailData,
                    headers: {'Content-Type': 'application/json' }
                }).then(response => {
                    this.loading = false;
                }).catch(error => {
                    console.log(error);
                    
                });

                // Close email modal
                setTimeout(() => {
                    let slider = this.$el.querySelector('.discussion-email-modal .slide-inline');
                    slider.classList.add('slide-left');
                    // reset
                    emailData = {};
                    this.$el.querySelector('#email').value = '';
                    // Close the modal with timeout
                    /*setTimeout(() => {
                        this.$root.$emit('bv::hide::modal', 'email-results-modal');
                    }, 900);*/

                }, 500);

            }
        }, mounted() {
            if(this.quizId) {
                this.formData.quizId = this.quizId;
            }

            if(this.quizName) {
                this.formData.quizName = this.quizName;
            }

            if(this.$attrs && this.$attrs['data-quiz-type'] && this.$attrs['data-quiz-type'] === 'symptom-checker') {
                // if needed
            }
            document.body.onclick = function(e) {   
                if (window.event) {
                    e = event.srcElement;
                }
                else {
                    e = e.target;
                }
                if (e.className && e.className.indexOf('buttondisable') != -1) {
                    if (this.submitted = true) {
                        e.setAttribute('disabled', 'disabled');
                    }
                    else if (this.submitted = false) {
                        e.removeAttribute('disabled');
                    }
                }
            }

        },
        created() {
            
            inputEventBus.$on('hiddenInputInit', (value, id, el) => {
                this.$nextTick(() => {
                    const isParent = this.checkParent(el);
                    if(isParent) {
                        this.formData[id] = value;
                    }
                });
            });
            inputEventBus.$on('inputInit', (value, id, el) => {
                this.$nextTick(() => {
                    const isParent = this.checkParent(el);
                    if(isParent) {
                        this.formData[id] = value;
                    }
                });
            });
            inputEventBus.$on('inputUpdated', (value, id, el, category) => {
                if(this.formData[id] !== value) {
                    const isParent = this.checkParent(el);
                    // console.log('Is Parent? ', isParent); true
                    if(isParent) {
                        if(el.type === 'checkbox') {
                            this.getCheckedItems(id);
                        } else if(category != undefined) {
                           // For Quiz with category, icon, question, answer
                           let obj = {};
                           obj.id = id;
                           obj.value = el.dataset.resultcardsuffixtext ? `${value} ${el.dataset.resultcardsuffixtext}` : value;
                           obj.icon = el.dataset.icon;
                           obj.question = el.dataset.question;
                           obj.category = category;
                           obj.colorcode = el.dataset.colorcode;

                           let categoryObj = {};
                           categoryObj.category = category;
                           categoryObj.priority = +(el.dataset.priority);
                           categoryObj.remainingCategory = [];
                          
                           let arr = this.formData.symptoms;
                           let categoryTypeArr = this.categoryType;
                           if (this.formData.symptoms.length === 0) {
                               this.formData.symptoms.push(obj);
                               this.categoryType.push(categoryObj);
                           } else {
                               let elementExist = arr.find(element => element['id'] === id);
                               if(elementExist !== undefined) {
                                    let i = arr.indexOf(elementExist);
                                    //arr[i] = obj;
                                    this.$set(arr, i, obj);
                                    this.$set(categoryTypeArr, i, categoryObj);
                               } else {
                                   arr.push(obj);
                                   categoryTypeArr.push(categoryObj);
                               }
                           }
                        } else {
                            this.formData[id] = value;
                            // console.log('Form Data')
                            // console.log(this.formData);
                        }
                        this.categoryType = this.categoryType.reduce((unique, o) => {
                            if(!unique.some(obj => obj.category === o.category)) {
                                unique.push(o);
                            }
                            return unique;
                        },[]);
                        this.$forceUpdate();
                    }
                }
            });
            this.EventBus.$on('stepChanged', (step) => {
                this.activeStep = step;
                this.clearAnswers();
            });
        }
    }
</script>




// WEBPACK FOOTER //
// src/app/components/aha-transition-group-form.vue